export const COMMUNITY_DETAILS_TABS_NAMES = {
  SUMMARY: "Summary",
  HOMES: "Homes",
  CONTACTS: "Contacts",
  SUPPLIERS: "Suppliers",
};

export const COMMUNITY_DETAILS_TABS = Object.values(
  COMMUNITY_DETAILS_TABS_NAMES
).map((name) => ({
  label: name,
  value: name.toLowerCase(),
}));
